import clamp from 'lodash/clamp.js';
import isString from 'lodash/isString.js';
import round from 'lodash/round.js';
import { ParamTypeNumber } from '../components/Purchase/LotParams/LotParam.type.js';

interface Options {
  placeholder?: string;
}

export const formatLotParamNumber = (
  type: ParamTypeNumber,
  value: any,
  options: Options & Intl.NumberFormatOptions = {},
): string => {
  const { format, integer, unsigned, range } = type;

  const { placeholder = '—', currencyDisplay = 'symbol' } = options;

  if (range) {
    const typeWithoutRange = { ...type, range: false };
    return [
      formatLotParamNumber(typeWithoutRange, value?.[0]),
      formatLotParamNumber(typeWithoutRange, value?.[1]),
    ].join(' — ');
  }

  let number = parseFloat(value);

  if (Number.isNaN(number)) {
    return placeholder;
  }

  if (integer) {
    number = round(value);
  }
  if (unsigned) {
    number = clamp(value, 0, Infinity);
  }

  const isGeneric = format === 'decimal';
  const isPercent = format === 'percent';
  const isCurrency = format === 'currency';
  const isUnit = format === 'unit';

  const formatParams: Intl.NumberFormatOptions = {
    style: [
      isGeneric && 'decimal',
      isPercent && 'decimal',
      isCurrency && 'currency',
      isUnit && 'decimal',
    ].find(isString) as any,
    minimumFractionDigits: 0,
    maximumFractionDigits: 5,
  };

  if (isCurrency) {
    const { currencyCode } = type;
    formatParams.currency = currencyCode || 'RUB';
    formatParams.currencyDisplay = currencyDisplay;
  }

  if (isPercent) {
    formatParams.maximumFractionDigits = 2;
  }
  if (isCurrency) {
    formatParams.maximumFractionDigits = 2;
  }
  if (isUnit) {
    formatParams.maximumFractionDigits = 5;
  }
  if (integer) {
    formatParams.minimumFractionDigits = 0;
    formatParams.maximumFractionDigits = 0;
  }

  return new Intl.NumberFormat('ru-RU', formatParams).format(number);
};
